export default __webpack_public_path__ + "static/media/ninos-Personaje-Banner-03-1.eef0c5ab.png";